import MyResponsivePie from "../PieChart";

const InterestChart = ({ results = [] }) => {
  let yes = 0, no = 0;

  results.forEach(result => {
    const interested = result.interested;

    if (interested === "yes") yes++;
    else no++;
  });


  const data = [
    {
      "id": "Yes",
      "label": "Yes",
      "value": yes,
      "color": "hsl(167, 70%, 50%)"
    },
    {
      "id": "No",
      "label": "No",
      "value": no,
      "color": "hsl(76, 70%, 50%)"
    },
  ];

  return <MyResponsivePie data={data} />;
}

export default InterestChart;
